import DatePicker from '../date-picker/DatePicker';
import { ViewMode } from '../date-picker/enum';
export default class WeekPicker extends DatePicker {
    getWrapperClassNames() {
        const { prefixCls } = this;
        return super.getWrapperClassNames(`${prefixCls}-week-picker-wrapper`);
    }
}
WeekPicker.displayName = 'WeekPicker';
WeekPicker.defaultProps = {
    ...DatePicker.defaultProps,
    mode: ViewMode.week,
};
